import { hasConditionValue } from "@utils/conditionOperators";

export function conditionCardToken(cardToken = "") {
  return typeof cardToken === "object" ? cardToken?.card_token : cardToken;
}

export function conditionReference(condition) {
  if (typeof condition.card_token === "object") {
    return Object.values(condition.card_token);
  } else {
    return [condition.card_token];
  }
}

export const isEffectiveCondition = (condition) =>
  !!conditionCardToken(condition?.card_token) && hasConditionValue(condition);

export const hasEffectiveConditions = (conditions) =>
  (conditions ?? []).some((entry) =>
    Array.isArray(entry?.group_conditions) ? entry.group_conditions.some(isEffectiveCondition) : isEffectiveCondition(entry),
  );
